export const users = {
  ap: 0,
  ins: 1
};
